export default __webpack_public_path__ + "static/media/euresto_01.1aa66184.png";